import { render } from "./ResolveComplaints.vue?vue&type=template&id=3f53aae4&ts=true"
import script from "./ResolveComplaints.vue?vue&type=script&lang=ts"
export * from "./ResolveComplaints.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__